module.exports = __webpack_public_path__ + "media/standalone/download_only-f880a295.svg";